import { render, staticRenderFns } from "./MarketingPlans.vue?vue&type=template&id=13a43083"
import script from "./MarketingPlans.vue?vue&type=script&lang=js"
export * from "./MarketingPlans.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlans.vue?vue&type=style&index=0&id=13a43083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports